<template>
  <div class="home-view">
    <h1>这是首页</h1>
  </div>
</template>

<script>
export default {
  name: 'HomeView',

}
</script>

<style scoped>
.home-view {
  padding: 20px;
}
</style>